export class DrawHolderEvent
{
    static SELECT_INSTRUMENT: string = 'DrawHolderEvent.SELECT_INSTRUMENT';
    static SELECT_COLOR: string = 'DrawHolderEvent.SELECT_COLOR';
    static SELECT_SIZE: string = 'DrawHolderEvent.SELECT_SIZE';
    static TEXT_DONE: string = 'DrawHolderEvent.TEXT_DONE';
    static NEED_BACKUP: string = 'DrawHolderEvent.NEED_BACKUP';
}
